import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=2395eab6&scoped=true&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"
import style0 from "./canvas.vue?vue&type=style&index=0&id=2395eab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395eab6",
  null
  
)

export default component.exports